import { createFeatureSelector } from '@ngrx/store';
import {
  CouponsetsAttributes,
  MerchantCreateNewState,
  MerchantDetailsState,
  MerchantGeneralState,
  MerchantOtherState,
  MerchantSearchState,
  MerchantSummaryState,
} from '../models/merchant.model';
import { MerchantCouponsetsAttributesReducer } from './couponsets-attributes.reducer';
import { MerchantCreateNewReducer } from './create-new.reducer';
import { MerchantDetailsReducer } from './details.reducer';
import { MerchantGeneralReducer } from './general.reducer';
import { MerchantOtherReducer } from './other.reducer';
import { MerchantSearchReducer } from './search.reducer';
import { MerchantSummaryReducer } from './summary.reducer';

export const featureMerchantName = 'Merchant';

export interface DragonflyMerchantState {
  merchantSearch: MerchantSearchState;
  merchantCreateNew: MerchantCreateNewState;
  merchantSummary: MerchantSummaryState;
  merchantCouponset: CouponsetsAttributes;
  merchantDetails: MerchantDetailsState;
  merchantGeneral: MerchantGeneralState;
  merchantOther: MerchantOtherState;
}

export const moduleMerchantReducers = {
  merchantSearch: MerchantSearchReducer,
  merchantCreateNew: MerchantCreateNewReducer,
  merchantSummary: MerchantSummaryReducer,
  merchantCouponset: MerchantCouponsetsAttributesReducer,
  merchantDetails: MerchantDetailsReducer,
  merchantGeneral: MerchantGeneralReducer,
  merchantOther: MerchantOtherReducer,
};

export const getDragonflyMerchantState =
  createFeatureSelector<DragonflyMerchantState>(featureMerchantName);
